import { FormatRotate90Icon } from './FormatRotate90Icon';

/**
 * author: Google
 * id 99448D5B-50D3-4F49-8E88-DD75F7DFB231
 * name format-rotate-90
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-rotate-90.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatRotateNinetyIcon = FormatRotate90Icon;
export default FormatRotateNinetyIcon